import React, {useState, useEffect, useMemo, useRef} from 'react';
import {Bar} from 'react-chartjs-2';
import 'chartjs-plugin-dragdata';
import {CategoryScale, Chart, LinearScale, BarElement} from 'chart.js';
import '../CheckinGraph.css';
Chart.register(LinearScale, CategoryScale, BarElement);

/**
 * La vue du graphique du checkin
 * @param {*} props props
 * @return {JSX}
 */
export default function CheckinViewGraph(props) {
  const [shouldRedraw] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const dataRef = useRef(props.data);

  useEffect(() => {
    dataRef.current = props.data;
  }, [props.data]);

  const buildDataSet = (data) => {
    const labels = data.map((c) => {
      if (c.label2 !== undefined) {
        let label = c.label2;
        const words = label.split(' ');
        const pop = words.pop();

        label = words.join(' ');
        const substrings = [];

        for (let i = 0; i < label.length; i += 19) {
          substrings.push(label.substr(i, 19));
        }

        substrings.push(pop);
        return substrings;
      } else {
        return ' ';
      }
    });

    const options = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            data: data.map((c) => c.value),
            fill: true,
            tension: 0.4,
            borderWidth: 0,
            borderColor: 'black',
            backgroundColor: data.map((c) => c.color),
            pointHitRadius: 25,
          },
        ],
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'linear',
            min: 0,
            max: 10,
            display: true,
            title: {
              color: 'black',
              display: true,
              text: 'Tâches',
              font: {
                size: 20,
              },
            },
            ticks: {
              color: 'black',
              display: false,
              font: {
                size: 20,
              },
            },
          },
          y: {
            title: {
              display: false,
            },
            ticks: {
              display: true,
              align: 'center',
              color: 'black',
              font: {
                size: '13px',
              },
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };
    return options;
  };

  const localOption = useMemo(() => buildDataSet(props.data), [props.data]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 200);
  }, []);

  return (
    <div className="chart-container" style={{height: props.data.length * 100 + 'px', width: '80vw'}}>
      {isLoaded && (
        <Bar
          redraw={shouldRedraw}
          data={localOption.data}
          options={localOption.options}
          plugins={localOption.plugins} />
      )}
    </div>
  );
}
